// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-bottom[data-v-ef40c93c] {\n  border-bottom: 1px solid #e8eef1;\n}\n.per-min-cost[data-v-ef40c93c] {\n  color: #A6A4A6;\n}", ""]);
// Exports
module.exports = exports;
